import axios from "axios";
import Cookies from "js-cookie";
import { API_BASE_URL } from "./config";

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    AppKey: "ABBDC7B8-4B48-472C-886D-182B61EC223B",
  },
});

//  Add token to each request dynamically
instance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("cls_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
